'use client';

import { ImageCarousel } from '@/components/sections/about/team/image-carousel/image-carousel';
import PrServiceCard from '@/components/sections/pr/pr-service/pr-service-card';
import PrServiceCardMobi from '@/components/sections/pr/pr-service/pr-service-card-mobi';
import H2 from '@/components/typography/h2';
import H3 from '@/components/typography/h3';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function PrService() {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);

    const prServiceData: {
        title: string;
        description: string;
    }[] = t('services.list', { returnObjects: true }) as {
        title: string;
        description: string;
    }[];

    return (
        <>
            <div id="pr-service" />
            {/* Desktop view */}
            <div className="hidden lg:block">
                <div className="border-primary flex flex-col items-center justify-center gap-5 px-5 py-15 lg:pt-30">
                    <div className="flex w-full gap-24">
                        <div className="w-5/12">
                            <div className="sticky top-[11rem] mr-4 ml-auto max-w-[612px]">
                                <H2 className="mb-8">{t('services.title')}</H2>
                            </div>
                        </div>
                        <div className="w-6/12">
                            <div className="mt-[-1rem] grid grid-cols-2 gap-[20px]">
                                {prServiceData.map((item, index) => (
                                    <PrServiceCard key={index} item={item} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile view */}
            <div className="block lg:hidden">
                <div className="flex flex-col items-start justify-center px-6 pt-[3.5rem]">
                    <div className="flex flex-col gap-3">
                        <H3 variant="notItalic">{t('services.title')}</H3>
                    </div>
                    <div className="flex flex-col gap-[0.62rem] pt-[2.5rem] pb-[2.5rem]">
                        {prServiceData.map((item, index) => (
                            <PrServiceCardMobi
                                key={index}
                                item={item}
                                index={index}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div className="border-primary relative flex flex-col items-center gap-20 border-b pt-[3.5rem] pb-40 lg:pt-[6.5rem]">
                <ImageCarousel
                    className="-ml-[12rem] w-[calc(100%+12rem)]"
                    height={{
                        mobile: 288,
                        desktop: 670,
                    }}
                    slides={[
                        {
                            src: '/images/pr/pr-1.png',
                        },
                        {
                            src: '/images/pr/pr-2.png',
                        },
                        {
                            src: '/images/pr/pr-3.png',
                        },
                        {
                            src: '/images/pr/pr-4.png',
                        },
                        {
                            src: '/images/pr/pr-5.png',
                        },
                        {
                            src: '/images/pr/pr-6.png',
                        },
                        {
                            src: '/images/pr/pr-7.png',
                        },
                        {
                            src: '/images/pr/pr-8.png',
                        },
                    ]}
                />
            </div>
        </>
    );
}
